<template>
  <section class="section-padding">
    <div class="container">
      <div class="columns is-multiline box">
        <div class="column is-12">
          <h1 class="title">Simulador de círculos</h1>
          <p class="has-text-grey">Distribuye socios activos en nuevos círculos sin modificar la información real.</p>
        </div>
        <div class="column is-12 mt-5"><Simulator /></div>
      </div>
    </div>
  </section>
</template>
<script>
import Simulator from '../components/simulator.vue';
export default { components: { Simulator } };
</script>
